import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import strings from '../../locale/en'
import {
  getSessionList,
  deleteSession,
  getSessionById,
  getZoomUsers,
  saveSession
} from './api'
import {
  InitialState,
  GetSessionListResponse,
  Session,
  ZoomUser,
  AddSessionForm,
  UpdateFormValue,
  SaveSessionResponse
} from './types'

const initialState: InitialState = {
  isLoading: false,
  sessionList: null,
  formValues: {
    branchId: [],
    branchIds: [],
    batchId: [],
    batchIds: [],
    coachingCentreId: '',
    courseId: '',
    sessionDate: '',
    startTime: '',
    topicName: '',
    endTime: '',
    sessionName: '',
    sessionType: '',
    subjectId: '',
    teacherId: '',
    platform: '',
    webExUserId: '',
    zoomUserId: ''
  },
  formErrors: {
    branchId: '',
    branchIds: '',
    batchId: '',
    batchIds: '',
    coachingCentreId: '',
    coachingCentreName: '',
    courseId: '',
    sessionDate: '',
    startTime: '',
    topicName: '',
    endTime: '',
    sessionName: '',
    sessionType: '',
    subjectId: '',
    teacherId: '',
    platform: '',
    webExUserId: '',
    zoomUserId: ''
  },
  error: '',
  selectedSession: null
}

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    resetSession: (state) => {
      state.selectedSession = null
    },
    setFormValues: (state, action: PayloadAction<AddSessionForm>) => {
      state.formValues = initialState.formValues
      state.formValues = action.payload
    },
    updateFormErrors: (state, action: PayloadAction<UpdateFormValue>) => {
      state.formErrors[action.payload.key] = action?.payload?.value
    },
    resetError: (state) => {
      state.error = ''
    },
    resetValues: (state) => {
      state.formValues = initialState.formValues
      state.formErrors = initialState.formErrors
    },
    updateFormValues: (state, action: PayloadAction<UpdateFormValue>) => {
      state.formValues[action.payload.key] = action?.payload?.value
      if (state.formErrors) {
        state.formErrors[action.payload.key] = ''
      }
      if (action.payload.key === 'coachingCentreId') {
        state.formValues.branchIds = []
        state.formValues.batchIds = []
        state.formValues.branchId = []
        state.formValues.batchId = []
        state.formValues.courseId = ''
      }
      if (action.payload.key === 'courseId') {
        state.formValues.branchIds = []
        state.formValues.batchIds = []
        state.formValues.branchId = []
        state.formValues.batchId = []
        state.formValues.subjectId = ''
      }

      if (action.payload.key === 'branchId') {
        state.formValues.branchId = action?.payload?.value
        state.formValues.batchId = []
      }
      if (action.payload.key === 'batchId') {
        state.formValues.batchId = action?.payload?.value
      }
      if (action.payload.key === 'platform') {
        state.formValues.zoomUserId = ''
        state.formValues.webExUserId = ''
      }
    }
  },
  extraReducers: {
    [getSessionList.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getSessionList.fulfilled.toString()]: (
      state,
      action: PayloadAction<GetSessionListResponse>
    ) => {
      state.isLoading = false
      state.sessionList = action?.payload
    },
    [getSessionList.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [deleteSession.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [deleteSession.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [deleteSession.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getSessionById.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getSessionById.fulfilled.toString()]: (
      state,
      action: PayloadAction<Session | null>
    ) => {
      state.isLoading = false
      state.selectedSession = action?.payload
    },
    [getSessionById.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getZoomUsers.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getZoomUsers.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<ZoomUser>>
    ) => {
      state.isLoading = false
      state.zoomUsers = action?.payload
    },
    [getZoomUsers.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [saveSession.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [saveSession.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = strings.validationMessages.session.saveSessionFailed
    },
    [saveSession.fulfilled.toString()]: (
      state,
      action: PayloadAction<SaveSessionResponse>
    ) => {
      state.isLoading = false
      state.formErrors = action.payload?.formErrors
      state.error = action.payload?.error || ''
    }
  }
})

export default sessionSlice.reducer
